import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Loader2, Mail, X, Send } from 'lucide-react';

/**
 * Daily report email settings component
 */
export const DailyReportSettings = ({
  dailyReportEmails,
  dailyReportEnabled,
  dailyReportLoading,
  sendingTestReport,
  onEmailChange,
  onClearEmail,
  onSave,
  onSendTest
}) => {
  return (
    <Card className="mb-6 border-indigo-200 bg-indigo-50/30">
      <CardHeader>
        <CardTitle className="font-serif text-lg text-indigo-700 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Mail className="w-5 h-5" />
            Daily Report Email Settings
          </div>
          {dailyReportEnabled && (
            <Badge className="bg-indigo-100 text-indigo-700">Active</Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          Configure up to 3 email addresses to receive daily activity reports automatically.
        </p>
        <div className="space-y-3">
          {dailyReportEmails.map((email, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="text-sm font-medium text-muted-foreground w-6">
                {index + 1}.
              </span>
              <div className="relative flex-1">
                <Input
                  type="email"
                  placeholder={`Email address ${index + 1}`}
                  value={email}
                  onChange={(e) => onEmailChange(index, e.target.value)}
                  className="pr-10"
                  data-testid={`daily-report-email-${index}`}
                />
                {email && (
                  <button
                    type="button"
                    onClick={() => onClearEmail(index)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="flex gap-2 mt-4">
          <Button
            onClick={onSave}
            disabled={dailyReportLoading}
            className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white"
            data-testid="save-daily-report-btn"
          >
            {dailyReportLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
            Save
          </Button>
          <Button
            onClick={onSendTest}
            disabled={sendingTestReport || !dailyReportEnabled}
            variant="outline"
            className="flex-1 border-indigo-300 text-indigo-700 hover:bg-indigo-50"
            data-testid="send-test-report-btn"
          >
            {sendingTestReport ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}
            Send Now
          </Button>
        </div>
        <p className="text-xs text-muted-foreground mt-3 text-center">
          {dailyReportEnabled 
            ? `Reports sent daily at 6 AM IST to ${dailyReportEmails.filter(e => e.trim()).length} email(s)` 
            : 'Add at least one email to enable daily reports'}
        </p>
      </CardContent>
    </Card>
  );
};

export default DailyReportSettings;
